// extracted by mini-css-extract-plugin
export default {"borderBottom":"AdminMobileMonthSaleStat_borderBottom__oiHyt","prevIcon":"AdminMobileMonthSaleStat_prevIcon__TheHu","nextIcon":"AdminMobileMonthSaleStat_nextIcon__1KrrL"};